import { createFileRoute } from '@tanstack/react-router'
import { ArticleList } from '@/features/articles/pages/article-list'

export const Route = createFileRoute('/_authenticated/articles/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ArticleList />
}
